import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dialog, Input, InputAdornment, Radio, Upload } from 'tdesign-react';
import { addToTabs } from '@/slices/resourceSlice';
import Text from '@/components/Text';
import Form from '@/components/Form';

// 连接
const { FormItem } = Form;

function ConnectModal({ visible, handleClose, detail, addToTabs }) {
  const [form] = Form.useForm();
  const type = Form.useWatch('type', form);

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        ...detail,
        hostUser: 'appadmin',
        type: '1',
      });
    } else {
      form.resetFields();
    }
  }, [detail, visible, form]);

  const handleSubmit = async (values) => {
    const parmas = {
      ...values,
    };
    // 秘钥
    if (type === '2') {
      parmas.prvKeyName = values.hostKey[0].name;
    }
    delete parmas.type;
    delete parmas.hostKey;
    addToTabs({ ...parmas, clusterId: detail.clusterId, id: detail.id });
    handleClose();
  };
  return (
    <Dialog
      header='Web-SSH'
      onClose={() => handleClose()}
      visible={visible}
      onConfirm={() => form.submit()}
      placement='center'
      width={686}
    >
      <Form form={form} onFinish={handleSubmit} style={{ width: '90%' }}>
        <FormItem name='hostName' label='所属集群'>
          <Text />
        </FormItem>
        <FormItem label='IP地址' requiredMark>
          <FormItem name='hostUser' rules={[{ required: true, message: '请输入用户名' }]}>
            <InputAdornment prepend='ssh'>
              <Input placeholder='用户名' style={{ width: 83 }} />
            </InputAdornment>
          </FormItem>
          <FormItem name='hostIp' rules={[{ required: true, message: '请输入主机/IP' }]}>
            <InputAdornment prepend='@'>
              <Input placeholder='主机/IP' style={{ width: 140 }} />
            </InputAdornment>
          </FormItem>
          <FormItem name='hostPort' rules={[{ required: true, message: '请输入端口' }]}>
            <InputAdornment prepend='-p'>
              <Input placeholder='端口' autocomplete='new-password' style={{ width: 83 }} />
            </InputAdornment>
          </FormItem>
        </FormItem>
        <FormItem name='serviceIp' label='服务地址'>
          <Text />
        </FormItem>
        <FormItem name='type' label='验证方式' rules={[{ required: true }]}>
          <Radio.Group>
            <Radio.Button value='1'>密码验证</Radio.Button>
            <Radio.Button value='2'>密钥验证</Radio.Button>
          </Radio.Group>
        </FormItem>
        {type === '1' && (
          <FormItem name='passwd' label='密码' rules={[{ required: true, message: '请输入密码' }]}>
            <Input type='password' autocomplete='new-password' placeholder='密码' />
          </FormItem>
        )}
        {type === '2' && (
          <FormItem name='hostKey' label='上传秘钥' rules={[{ required: true }]}>
            <Upload
              theme='file'
              accept='application/x-x509-ca-cert'
              action='/api/ops_hosts/uploadPrvKey'
              headers={{ 'x-auth-token': localStorage.getItem('token') }}
            />
          </FormItem>
        )}
      </Form>
    </Dialog>
  );
}

export default connect(null, {
  addToTabs,
})(ConnectModal);
